"use strict";

import angular from "angular";
import { UserDataAdapter } from "../../presentation/adpters/UserDataAdapter";
import { AccountingEntity } from "../../entity/AccountingEntity";
import { Accounting } from "../../gateway/Accounting/Accounting";
import { AccountingPlanHttpGateway } from "../../gateway/AccountingPlan/AccountingPlanHttpGateway";
import { User } from "../../gateway/User/User";
import { LocalStoreService } from "../../presentation/services/LocalStoreService";
import {
    accountingUsers,
    accoutingTrialUsers,
    nucontersUsers
} from "../../utils/users-roles/users-roles";

angular.module("nucont.accounting").config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider.state("nucont.accounting", {
        url: "contabilidade/:accountingId?accIdReference",
        params: {
            accountingId: {
                value: null
            },
            accIdReference: { value: null, dynamic: true }
        },
        lazyLoad(transition) {
            const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
            return import(
                /* webpackChunkName: "feature-accounting" */ "./accounting.view.component"
            ).then(() => $ocLazyLoad.inject("nucont.accounting"));
        },
        data: {
            rolesGuard: [
                ...nucontersUsers,
                ...accountingUsers,
                ...accoutingTrialUsers
            ]
        },
        views: {
            "main@": {
                component: "adminLayoutComponent"
            },
            "admin@nucont.accounting": {
                component: "accountingViewComponent"
            }
        },
        resolve: {
            jwtVerified: [
                "JWTService",
                (JWTService) => JWTService.verifyTokenOnce()
            ],
            user: [
                () => {
                    let count = 0;
                    return new Promise((resolve, reject) => {
                        const checkUser = () => {
                            console.log("CHECK USER 1");
                            if (count > 3) return resolve(true);
                            if (new UserDataAdapter().user()?.role) {
                                return resolve(true);
                            } else {
                                setTimeout(() => {
                                    count++;
                                    checkUser();
                                }, 500);
                            }
                        };
                        checkUser();
                    });
                }
            ],
            navigationConfig: [
                "$stateParams",
                "NavigationService",
                ($stateParams, NavigationService) => {
                    NavigationService.setParams(
                        "accountingId",
                        $stateParams.accountingId
                    );
                    NavigationService.setHref();
                }
            ],
            accountingData: [
                "$stateParams",
                "$state",
                "UserProfileSidenavService",
                "LayoutService",
                "AccountingFactory",
                "AccountingDataService",
                "JourneyService",
                "JWTService",
                async (
                    $stateParams,
                    $state,
                    UserProfileSidenavService,
                    LayoutService,
                    AccountingFactory,
                    AccountingDataService,
                    JourneyService,
                    JWTService
                ) => {
                    if (
                        !$stateParams.accIdReference &&
                        !$stateParams.accountingId
                    )
                        return $state.go("nucont.accountings.customers");
                    const AccountingGetaway = new Accounting();
                    const UserGateway = new User();
                    const accountingId =
                        $state.params.accIdReference ||
                        $state.params.accountingId ||
                        $stateParams.accIdReference ||
                        $stateParams.accountingId;
                    const accountingData = await AccountingGetaway.getById(
                        accountingId
                    );
                    if (!accountingData) {
                        console.log("SIGN OUT 2");
                        JWTService.signout();
                        return {};
                    }
                    JourneyService.reset();
                    JourneyService.configSystemsByPreferences(
                        accountingData.preferences?.mySystems,
                        accountingData.preferences?.onboarding
                    );
                    const localStoreService = new LocalStoreService();
                    localStoreService.setItem("accounting", {
                        _id: accountingData?._id,
                        name: accountingData?.name,
                        plan: accountingData?.plan?.name,
                        contract: accountingData?.contract,
                        status: accountingData?.status,
                        createdAt: accountingData?.createdAt
                    });
                    UserProfileSidenavService.setAccounting(accountingData);
                    AccountingFactory.setDocument(accountingData);
                    const accountingEntity = AccountingEntity.restore(
                        accountingData
                    );
                    AccountingDataService.setEntity(accountingEntity);
                    const noShow = UserGateway.checkPermission({
                        roles: new UserDataAdapter().user()?.roles,
                        granted: ["Empresa"]
                    });
                    let isDefaulter = false;
                    if (noShow) {
                        isDefaulter = false;
                    } else {
                        isDefaulter = accountingEntity.isDefaulter();
                    }
                    LayoutService.setAttrs([
                        {
                            object: "alertNotification",
                            path: "enabled",
                            value: isDefaulter
                        }
                    ]);
                    return accountingData;
                }
            ],
            accountingPlanEntity: [
                "accountingData",
                "NavigationService",
                "AccountingPlanService",
                "JWTService",
                async (
                    accountingData,
                    NavigationService,
                    AccountingPlanService,
                    JWTService
                ) => {
                    const accountingPlanHttpGateway = new AccountingPlanHttpGateway();
                    const contract = accountingData?.contract;
                    const accountingPlanEntity = await accountingPlanHttpGateway.getPlanByName(
                        contract
                    );
                    if (!accountingPlanEntity.props._id) {
                        console.log("SIGN OUT 3");
                        JWTService.signout();
                        return accountingPlanEntity;
                    }
                    NavigationService.setValidationsContract(
                        accountingPlanEntity
                    );
                    if (window.HubSpotConversations) {
                        if (
                            !accountingPlanEntity.isContractedFeature({
                                value: "Support"
                            })
                        ) {
                            window.HubSpotConversations.widget.remove();
                        }
                    }
                    AccountingPlanService.init({
                        accountingPlanEntity
                    });
                    return accountingPlanEntity;
                }
            ],
            isAccountingBlocked: [
                "$state",
                "accountingData",
                "JWTService",
                async ($state, accountingData, JWTService) => {
                    setTimeout(() => {
                        if (
                            $state.current.name ===
                            "nucont.accounting.mySubscription"
                        )
                            return false;
                        const accountingEntity = new AccountingEntity(
                            accountingData
                        );
                        const isBlocked = accountingEntity.isAccessBlockedByFinancial(
                            {
                                user: new UserDataAdapter().user()
                            }
                        );
                        if (isBlocked) {
                            console.log("SIGN OUT 4");
                            JWTService.signout();
                        }
                    }, 1000);
                }
            ]
        }
    });
}
